import { ChangeDetectionStrategy, Component, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
  selector: 'button-group',
  templateUrl: './button-group.component.html',
  styleUrl: './button-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ButtonGroupComponent {
  public showDividers = input(true);

  private overlayRef: OverlayRef | null = null;
  
  constructor(private overlay: Overlay, private viewContainerRef: ViewContainerRef) {}

  openAssignOptions(event: MouseEvent, template: TemplateRef<any>) {
    const target = event.target as HTMLElement;
    
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(target)
      .withPositions([
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetX: 50, offsetY: 25 },
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetX: 50, offsetY: 25 }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'transparent-backdrop'
    });

    const portal = new TemplatePortal(template, this.viewContainerRef);
    this.overlayRef.attach(portal);
    
    this.overlayRef.backdropClick().subscribe(() => this.closeAssignOptions());
  }

  closeAssignOptions() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
